<script >
  export let errors = null;
  export let schema;
  export let key;
  export let tooltips;
</script>

{#if schema}
  {#if schema.type == "object" && schema.description == "section"}
    <div class="accordion">
      <input type="checkbox" id={key} name="accordion-checkbox" hidden>
      <label class="accordion-header" for={key}>
        <i class="icon icon-arrow-right mr-1"></i>
        { key }
      </label>
      <div class="accordion-body">
        <slot>A field is not implemented</slot>
      </div>
    </div>
  {:else if schema.type == "boolean"}
    <div class="form-group">
        <div class="tile tile-centered">
            <div class="tile-content">
              {#if schema.title}
                <div class="tile-title">{schema.title}</div>
              {:else if key}
                <div class="tile-title">{key}</div>
              {/if}
            </div>
            <div class="tile-action">
                <div class="d-inline-block pr-2">No</div>
                <label class="form-switch">
                    <slot>A field is not implemented</slot>
                    <i class="form-icon"></i>Yes
                </label>
            </div>
        </div>
    </div>
  {:else}
    <div class="tile">
      {#if errors && errors.length}
        <div class="tile-icon">
          <div class="popover popover-right">
            <button type="button" class="btn btn-link"><i class="icon icon-stop centered"></i></button>
            <div class="popover-container">
              <ul class="menu">
                {#each errors as error}
                   <li class="menu-item">{error.message}</li>
                {/each}
              </ul>
            </div>
          </div>
        </div>
      {/if}
      <div class="tile-content">
        <div class="form-group">
          {#if schema.title && schema.type !== "object"}
            <label class="form-label">{schema.title}</label>
          {:else if key && schema.type !== "object"}
            <label class="form-label">{key}</label>
          {/if}
          <slot>A field is not implemented</slot>
        </div>
      </div>
      {#if schema.description}
        <div class="tile-action">
            <button type="button" class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip={schema.description}><i class="icon icon-message centered"></i></button>
        </div>
      {/if}
    </div>
  {/if}
{/if}


<style>
  .accordion .accordion-header {
		cursor: pointer;
		user-select: none;
		height: 1rem;
		padding: 0.2rem 0.2rem 0.2rem 0.2rem;
	}
	.accordion-body {
    padding-left: 1rem;
    margin: 0.4rem 0 0 0;
	}
  .form-group {
    margin: 0;
  }
  .form-switch {
      margin: 0.8rem 0;
      display: inline-block;
  }
  .popover .popover-container {
    left: -1.6rem;
    width: 200px;
    padding: 0.2rem;
  }
  .tile .tile-action {
    padding-top: 1rem;
  }
</style>